/*
 * ================
 *      IMAGES
 * ================
 */

// Import profile
import Perfil from "../img/Perfil.jpg";

// Import Icons
import AdobeXd from "../img/icons/icon-adobe-xd.svg";
import CSS from "../img/icons/icon-css3.svg";
import MySQL from "../img/icons/icon-database.svg";
import Git from "../img/icons/icon-git.svg";
import HTML from "../img/icons/icon-html5.svg";
import Javascript from "../img/icons/icon-js.svg";
import PHP from "../img/icons/icon-php.svg";
import VSC from "../img/icons/icon-VSC.svg";
import Bizagi from "../img/icons/icon-bizagi.svg";
import UML from "../img/icons/icon-UML.svg";
import MongoDB from "../img/icons/icon-mongodb.svg";
import NodeJs from "../img/icons/icon-nodejs.svg";
import Deploy from "../img/icons/icon-deploy.svg";
import GitHub from "../img/icons/icon-git-hub.svg";
import React from "../img/icons/icon-react.svg";
import Leader from "../img/icons/icon-leader.svg";
import Team from "../img/icons/icon-team.svg";

// Import Projects
import BlogArupajhana from "../img/projects/BlogArupajhana.jpg";
import CloneDeezer from "../img/projects/CloneDeezer.jpg";
import Cominfor from "../img/projects/Cominfor.jpg";
import DashboardCripto from "../img/projects/DashboardCripto.jpg";
import Fantasy from "../img/projects/Fantasy.jpg";
import OrangeCalc from "../img/projects/OrangeCalc.jpg";
import SabujchaTe from "../img/projects/SabujchaTe.jpg";
import Tetris from "../img/projects/Tetris.jpg";

/*
 * ================
 *   React-Icons
 * ================
 */

// Skills icons
import { MdTouchApp } from "react-icons/md";
import { FaLaptopCode, FaDatabase, FaToolbox } from "react-icons/fa";

// Services icons
import { MdDesignServices } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";
import {
  FaLock,
  FaChartPie,
  FaGraduationCap,
  FaCode,
  FaGithub,
} from "react-icons/fa";
import { MdWork } from "react-icons/md";

// Footer icons
import { GrMail, GrLinkedin } from "react-icons/gr";

/*
 * ================
 *     CONTENT
 * ================
 */

export const content = {
  skills: {
    title: "Skills",
    subtitle: "Mis habilidades técnicas",
    frontendIcon: FaLaptopCode,
    backendIcon: FaDatabase,
    toolsIcon: FaToolbox,
    frontendContent: [
      {
        id: 1,
        icon: MdTouchApp,
        name: "HTML5",
        logo: HTML,
        porcent: 90,
        progressBar: "HTML",
        text: [
          {
            paragraph:
              "Es un estándar que sirve como referencia del software que conecta con la elaboración de sitios y/o aplicativos web, es decir, define la estructura y el contenido de una página o aplicación web.",
          },
        ],
      },

      {
        id: 2,
        icon: MdTouchApp,
        name: "CSS3",
        logo: CSS,
        porcent: 70,
        progressBar: "CSS",
        text: [
          {
            paragraph:
              "Es un lenguaje de diseño gráfico que permite definir y crear la presentación de un documento estructurado escrito en un lenguaje demarcado.",
          },
          {
            paragraph:
              "Se utiiza para establecer el diseño visual de los documentos web e interfaces de usuario escritas en HTML.",
          },
        ],
      },

      {
        id: 3,
        icon: MdTouchApp,
        name: "javaScript",
        logo: Javascript,
        porcent: 40,
        progressBar: "Javascript",
        text: [
          {
            paragraph:
              "Es un lenguaje de programación que permite crear sitios y/o aplicativos web dinámicos que mejoran la experiencia de usuario durante su interacción o navegabilidad.",
          },
        ],
      },
    ],

    backendContent: [
      {
        id: 1,
        icon: MdTouchApp,
        name: "MySQL",
        logo: MySQL,
        porcent: 50,
        progressBar: "MySQL",
        text: [
          {
            paragraph:
              "Es un sistema de Gestión de Bases de Datos Relacionales (RDBMS) de código abierto basado en el lenguaje estructurado (SQL).",
          },
          {
            paragraph:
              "Permite almacenar toda la información que se desee en una base de datos relacional, además de facilitar la comunicación entre el aplicativo y el servidor.",
          },
        ],
      },

      {
        id: 2,
        icon: MdTouchApp,
        name: "php",
        logo: PHP,
        porcent: 40,
        progressBar: "PHP",
        text: [
          {
            paragraph:
              "Es un lenguaje de programación especialmente adecuado para el desarrollo web y que puede ser insertado en documentos HTML.",
          },
          {
            paragraph:
              "Se ejecuta en el lado del servidor que permite crear sitios dinámicos y conexiones con bases de datos relacionales.",
          },
        ],
      },
      {
        id: 3,
        icon: MdTouchApp,
        name: "Mongo DB",
        logo: MongoDB,
        porcent: 20,
        progressBar: "Mongo",
        text: [
          {
            paragraph:
              "Es un sistema de gestión de bases de datos no relacional (NoSQL) de código abierto.",
          },
          {
            paragraph:
              "Tiene un esquema flexible, es escalable y permite distribuir la base de datos en varios servidores para manejar un gran volumen de datos y alta disponibilidad.",
          },
        ],
      },
      {
        id: 4,
        icon: MdTouchApp,
        name: "Node Js - Express Js",
        logo: NodeJs,
        porcent: 20,
        progressBar: "Node",
        text: [
          {
            paragraph:
              "Node Js es un entorno de ejecución de JavaScript que permite ejecutar código JavaScript en un servidor, lo que permite crear aplicaciones web escalables y altamente concurrentes.",
          },
          {
            paragraph:
              "Express Js es un framework web para Node Js que proporciona una interfaz minimalista y flexible para crear aplicaciones web y API's.",
          },
        ],
      },
    ],

    toolsContent: [
      {
        id: 1,
        icon: MdTouchApp,
        name: "Adobe Xd",
        logo: AdobeXd,
        porcent: 80,
        progressBar: "Adobe",
        text: [
          {
            paragraph:
              "Es una herramienta que permite diseñar interfaces para sitios y/o aplicativos web, enfocándose en la experiencia de usuario (UI).",
          },
          {
            paragraph:
              "También facilita la creación de un prototipo que simula la interactividad del usuario con el sitio y/o aplicativo web.",
          },
        ],
      },
      {
        id: 2,
        icon: MdTouchApp,
        name: "Visual Studio Code",
        logo: VSC,
        porcent: 75,
        progressBar: "VSC",
        text: [
          {
            paragraph:
              "Es un editor de código fuente desarrollado por Microsoft. Esta herramienta permite escribir, editar y depurar el código en diferentes lenguajes de programación para la creación de diversas aplicaciones.",
          },
        ],
      },
      {
        id: 3,
        icon: MdTouchApp,
        name: "Git & GitHub",
        logo: Git,
        porcent: 70,
        progressBar: "Git",
        text: [
          {
            paragraph:
              "Git es un Sistema de Control de Versiones Distribuido que se utiliza para guardar diferentes versiones del código que puedan ser recuperables en cualquier momento.",
          },
          {
            paragraph:
              "GitHub es una plataforma web que permite alojar repositorios o proyectos administrados con Git.",
          },
        ],
      },
      {
        id: 4,
        icon: MdTouchApp,
        name: "BizAgi Modeler",
        logo: Bizagi,
        porcent: 80,
        progressBar: "Bizagi",
        text: [
          {
            paragraph:
              "Es una herramienta de modelado de procesos de negocio que permite diseñar, modelar y documentar procesos de manera visual.",
          },
          {
            paragraph:
              "El modelado de procesos usa el estándar BPMN (Business Process Model and Notation) que permite analizar, documentar y mejorar la eficiencia y efectividad del proceso.",
          },
        ],
      },
      {
        id: 5,
        icon: MdTouchApp,
        name: "Diagramación UML",
        logo: UML,
        porcent: 60,
        progressBar: "UML",
        text: [
          {
            paragraph:
              "UML (Unified Modeling Language) es un lenguaje de modelado de sistemas de software. Es un estándar que proporciona un conjunto de notaciones gráficas para representar diferentes aspectos en el diseño de un software.",
          },
          {
            paragraph:
              "También son útiles para validar que los requerimientos del sistema son correctos y para ayudar al desarrollo e implementación del software.",
          },
        ],
      },
    ],
  },

  services: {
    title: "Servicios",
    subtitle: "Que te ofrezco",
    serviceContent: [
      {
        id: 1,
        title: "Diseño",
        text: "Diseño de tu identidad de marca, creando experiencias digitales mediante la creatividad y la tecnología.",
        icon: MdDesignServices,
      },

      {
        id: 2,
        title: "Desarrollo",
        text: "Desarrollo de tu sitio y/o aplicación web a la medida de tu negocio, cumpliendo siempre con tus requerimientos y objetivos.",
        icon: FaCode,
      },

      {
        id: 3,
        title: "Seguridad",
        text: "Proyectos desarrollados con calidad, eficiencia y seguridad, generando los mejores resultados.",
        icon: FaLock,
      },

      {
        id: 4,
        title: "Competitividad",
        text: "Análisis de las necesidades de tu negocio para aportar las mejores soluciones tecnológicas que aumentaran tu productividad y competitividad.",
        icon: FaChartPie,
      },
    ],
  },

  projects: {
    title: "Proyectos",
    subtitle: "Mis desarrollos",
    projectContent: [
      {
        id: 1,
        title: "Cominfor",
        description:
          "Página web para la empresa Cominfor que ofrece servicios y productos relacionados con la tecnología.",
        technologies: [
          {
            name: "HTML",
            icon: HTML,
          },
          {
            name: "CSS",
            icon: CSS,
          },
          {
            name: "javaScript",
            icon: Javascript,
          },
          {
            name: "Líder de Proyecto",
            icon: Leader,
          },
        ],
        deploy: "http://cominfor.com/",
        deployIcon: Deploy,
        github: "",
        githubIcon: GitHub,
        category: "Web",
        image: Cominfor,
      },

      {
        id: 2,
        title: "Fantasy Sex Shop",
        description:
          "Aplicación web para el cliente Fantasy Sex Shop que cuenta con carrito de compras y mensaje directo a WhatsApp para adquirir los productos.",
        technologies: [
          {
            name: "javaScript",
            icon: Javascript,
          },
          {
            name: "React Js",
            icon: React,
          },
          {
            name: "Líder de Proyecto",
            icon: Leader,
          },
        ],
        deploy: "https://fantasy-sex-shop.vercel.app/home",
        deployIcon: Deploy,
        github: "",
        githubIcon: GitHub,
        category: "App",
        image: Fantasy,
      },

      {
        id: 3,
        title: "Dashboard Criptomonedas",
        description:
          "Págia web dinámica desarrollada como práctica académica para mostrar información de criptomonedas por medio de un consumo de API.",
        technologies: [
          {
            name: "javaScript",
            icon: Javascript,
          },
          {
            name: "React Js",
            icon: React,
          },
          {
            name: "Proyecto Colaborativo",
            icon: Team,
          },
        ],
        deploy: "https://dashboard-criptomonedas.vercel.app/",
        deployIcon: Deploy,
        github: "https://github.com/Nisanech/dashboard-criptomonedas",
        githubIcon: GitHub,
        category: "App",
        image: DashboardCripto,
      },

      {
        id: 4,
        title: "Juego Tetris",
        description:
          "Aplicación web donde se recrea el juego Tetris desarrollada como práctica académica.",
        technologies: [
          {
            name: "HTML",
            icon: HTML,
          },
          {
            name: "CSS",
            icon: CSS,
          },
          {
            name: "javaScript",
            icon: Javascript,
          },
          {
            name: "Líder de Proyecto",
            icon: Leader,
          },
          {
            name: "Proyecto Colaborativo",
            icon: Team,
          },
        ],
        deploy: "https://juego-tetris.netlify.app/",
        deployIcon: Deploy,
        github: "https://github.com/Nisanech/juego-tetris",
        githubIcon: GitHub,
        category: "Práctica",
        image: Tetris,
      },

      {
        id: 5,
        title: "Calculadora",
        description:
          "Aplicación web de una calculadora con funciones básicas desarrollada como práctica académica.",
        technologies: [
          {
            name: "HTML",
            icon: HTML,
          },
          {
            name: "CSS",
            icon: CSS,
          },
          {
            name: "javaScript",
            icon: Javascript,
          },
          {
            name: "Líder de Proyecto",
            icon: Leader,
          },
        ],
        deploy: "https://orange-calc.netlify.app/",
        deployIcon: Deploy,
        github: "https://github.com/Nisanech/Orangecalc",
        githubIcon: GitHub,
        category: "Práctica",
        image: OrangeCalc,
      },

      {
        id: 6,
        title: "Clon de Deezer",
        description:
          "Clon de la página web de Deezer desarrollada como práctica académica para diseño UI/UX y maquetación web.",
        technologies: [
          {
            name: "HTML",
            icon: HTML,
          },
          {
            name: "CSS",
            icon: CSS,
          },
          {
            name: "Líder de Proyecto",
            icon: Leader,
          },
          {
            name: "Proyecto colaborativo",
            icon: Team,
          },
        ],
        deploy: "https://clone-deezer.netlify.app/",
        deployIcon: Deploy,
        github: "https://github.com/Nisanech/landingpage-deezer",
        githubIcon: GitHub,
        category: "Web",
        image: CloneDeezer,
      },

      {
        id: 7,
        title: "Blog Arupajhana",
        description:
          "Página web estática tipo blog desarrollada como práctica académica para diseño UI/UX y maquetación web.",
        technologies: [
          {
            name: "HTML",
            icon: HTML,
          },
          {
            name: "CSS",
            icon: CSS,
          },
          {
            name: "javaScript",
            icon: Javascript,
          },
          {
            name: "Líder de Proyecto",
            icon: Leader,
          },
        ],
        deploy: "https://blog-arupajhana.netlify.app/",
        deployIcon: Deploy,
        github: "https://github.com/Nisanech/blog-arupajhana",
        githubIcon: GitHub,
        category: "Práctica",
        image: BlogArupajhana,
      },

      {
        id: 8,
        title: "Sabujcha Té",
        description:
          "Página web estática desarrollada como práctica académica para diseño UI/UX y maquetación web.",
        technologies: [
          {
            name: "HTML",
            icon: HTML,
          },
          {
            name: "CSS",
            icon: CSS,
          },
          {
            name: "Líder de Proyecto",
            icon: Leader,
          },
        ],
        deploy: "https://sabujcha-te.netlify.app/",
        deployIcon: Deploy,
        github: "https://github.com/Nisanech/SabujCha-Te",
        githubIcon: GitHub,
        category: "Práctica",
        image: SabujchaTe,
      },
    ],
  },

  aboutMe: {
    title: "Sobre mi",
    subtitle: "Contrátame",
    image: Perfil,
    iconStudies: FaGraduationCap,
    iconWork: MdWork,
    studiesContent: [
      {
        id: 1,
        program: "Bootcamp Desarrollo FullStack",
        academy: "EducaMas - Programate",
        year: "2023",
        position: "left",
      },
      {
        id: 2,
        program: "TG. Desarrollo de Software",
        academy: "SENA",
        year: "2021",
        position: "right",
      },

      {
        id: 3,
        program: "PR. Ingeniería Industrial",
        academy: "Universidad ECCI",
        year: "2018",
        position: "left",
      },

      {
        id: 4,
        program: "Seminario Lean Manufacturing",
        academy: "Universidad ECCI",
        year: "2015",
        position: "right",
      },

      {
        id: 5,
        program: "TG. Gestión de Procesos Industriales",
        academy: "Universidad ECCI",
        year: "2015",
        position: "left",
      },
    ],

    workContent: [
      {
        id: 1,
        company: "Colorpack Impresores SAS",
        jobTitle: "Gestor de Producción y Calidad",
        city: "Bogotá D.C.",
        startYear: "2018",
        endYear: "2022",
        position: "left",
      },

      {
        id: 2,
        company: "Campro Servicios Asociados SAS",
        jobTitle: "Asistente Operativo y de Calidad",
        city: "Bogotá D.C.",
        startYear: "2017",
        endYear: "2018",
        position: "right",
      },

      {
        id: 3,
        company: "Planta de Producción Avesco SAS",
        jobTitle: "Practicante Universitario",
        city: "Bogotá D.C.",
        startYear: "2016",
        endYear: "2017",
        position: "left",
      },
    ],
  },

  contact: {
    title: "Contacto",
    subtitle: "Contáctame",
  },

  footer: {
    footerContent: [
      {
        icon: FaGithub,
        url: "https://github.com/Nisanech",
      },

      {
        icon: GrLinkedin,
        url: "https://www.linkedin.com/in/nisanech/",
      },

      {
        icon: GrMail,
        url: "/contact",
      },

      {
        icon: IoLogoWhatsapp,
        url: "+57 320 251 0584",
      },
    ],
  },
};
